import React, { createContext, useContext, useEffect, useState } from 'react';
import api, { formatErrorDetail } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(undefined); // undefined = checking, null = not auth, obj = auth

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) { setAdmin(null); return; }
    (async () => {
      try {
        const { data } = await api.get('/auth/me');
        setAdmin(data);
      } catch {
        setAdmin(null);
      }
    })();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post('/auth/login', { email, password });
      if (data.token) localStorage.setItem('access_token', data.token);
      const me = await api.get('/auth/me');
      setAdmin(me.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('access_token');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
